import store from "../../store";

import {
  getAllDocNotesByID,
  getAllDocNotesService,
  postNewNoteService,
  editNoteService,
  deleteNoteService,
  uploadAttachmentService,
} from "./notesService";
import { fetchAllUsers } from "../PipelineActions/pipelineServices";

import { sortNotes } from "./notesMethods";

export const getNotesByDocID = (docID, docType) => dispatch => {
  getAllDocNotesByID(docID, docType)
    .then(response => {
      dispatch({
        type: "DOCUMENT_NOTES",
        payload: sortNotes(response.Comments),
      });
    })
    .catch(error => {
      console.error(error);
    });
};

export const addNote = note => dispatch => {
  dispatch({
    type: "ADD_NOTE",
    payload: note,
  });
  return Promise.resolve();
};

export const updateNotes = noteList => dispatch => {
  dispatch({
    type: "UPDATE_NOTES",
    payload: sortNotes(noteList),
  });
};

export const deleteNoteByNoteId = noteId => dispatch =>
  new Promise((resolve, reject) => {
    deleteNoteService(noteId)
      .then(() => {
        const { NotesStore } = store.getState();
        const { documentNotes = [] } = NotesStore;

        const note = documentNotes.find(docNote => docNote.id === noteId);
        let updatedNotes;
        if (note.base_comment_id === null) {
          updatedNotes = documentNotes.filter(
            noteThread => noteThread.id !== noteId,
          );
        } else {
          updatedNotes = documentNotes.map(noteThread => {
            if (noteThread.id === note.base_comment_id) {
              const updatedNote = {
                ...noteThread,
                replies: noteThread.replies.filter(
                  noteItem => noteItem.id !== note.id,
                ),
              };
              return updatedNote;
            }
            return noteThread;
          });
        }

        dispatch({
          type: "UPDATE_NOTES",
          payload: sortNotes(updatedNotes),
        });
        resolve();
      })
      .catch(() => {
        reject();
      });
  });

export const getAllDocNotes = docID => dispatch => {
  getAllDocNotesService(docID)
    .then(response => {
      dispatch({
        type: "DOCUMENT_NOTES",
        payload: response.Comments,
      });
    })
    .catch(error => {
      console.error(error);
    });
};

export const postNewNote = data => () =>
  new Promise((resolve, reject) => {
    postNewNoteService(data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });

export const editNote = data => () =>
  new Promise((resolve, reject) => {
    editNoteService(data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });

export const deleteNote = noteID => () =>
  new Promise((resolve, reject) => {
    deleteNoteService(noteID)
      .then(response => {
        console.debug(response);
        // Rewrite
        // take the response here and insert in the existing redux store instead of fetching all notes again
        resolve("success");
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });

export const uploadAttachment = formData => () =>
  new Promise((resolve, reject) => {
    const reduxState = store.getState();
    const {
      document: {
        opportunity: { crm_account: { id: accountID } = {} } = {},
      } = {},
    } = reduxState.DocumentStore;
    uploadAttachmentService(formData, accountID)
      .then(response => {
        console.debug(response);
        resolve(response.Attachment);
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });

export const fetchAllUsersForMentions = () => dispatch =>
  new Promise((resolve, reject) => {
    fetchAllUsers()
      .then(response => {
        dispatch({
          type: "MENTION_USERS",
          payload: response.users,
        });
        resolve(response);
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });
